//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        requisites: '',
        dateCreatedFrom: '',
        dateCreatedTo: '',
        dateDeletedFrom: '',
        dateDeletedTo: '',
        serviceList: [],
      },
    };
  },

  computed: {
    ...mapState('userRequisites', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('userRequisites', ['setFilters']),
  },
};
